import moment from 'moment'
export default {
    todaysLog: state => (scheduleDate) => state.emploe.filter(l => l.scheduleDate == scheduleDate),

    // getSegmentByScheduleIdSegmentTypeId: (state) => (segmentTypeId, scheduleId) => {
    //     console.log(state.employeeFiledTimeSheet)
    //     return state.employeeFiledTimeSheet.find((s) => s.segmentTypeId == segmentTypeId && s.employeeScheduleId == scheduleId)
        
    // },

    getCurrentUserSchedule: state => (shiftTypeId) => state.employeeSchedule.find((es) => es.shiftTypeId === shiftTypeId),
    
    getSegmentByScheduleIdSegmentTypeId: (state) => (segmentTypeId, scheduleId) => {
        console.log(state.calendarEvents)
        return state.calendarEvents.find((s) => s.segmentTypeId == segmentTypeId && s.employeeScheduleId == scheduleId)
        
    },
    
  
}